import { render, staticRenderFns } from "./CenterCUDialog.vue?vue&type=template&id=e5388066&scoped=true"
import script from "./CenterCUDialog.vue?vue&type=script&lang=js"
export * from "./CenterCUDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5388066",
  null
  
)

export default component.exports